import { damagingNameConstants } from "_constants";

const searchAdminDamagingParties = (searchTerm) => ({
  type: damagingNameConstants.SEARCH_DAMAGING_REQUEST,
  payload: { searchTerm },
});

const searchDamagingPartiesSuccess = (payload) => ({
  type: damagingNameConstants.SEARCH_DAMAGING_SUCCESS,
  payload,
});

const searchDamagingPartiesFailure = (error) => ({
  type: damagingNameConstants.SEARCH_DAMAGING_FAILURE,
  error,
});

const searchByClaimId = (claimId) => ({
  type: damagingNameConstants.SEARCH_BY_CLAIM_REQUEST,
  payload: { claimId },
});

const searchByClaimIdSuccess = (payload) => ({
  type: damagingNameConstants.SEARCH_BY_CLAIM_SUCCESS,
  payload,
});

const searchByClaimIdFailure = (error) => ({
  type: damagingNameConstants.SEARCH_BY_CLAIM_FAILURE,
  error,
});

const searchInClaims = (damagingName) => ({
  type: damagingNameConstants.SEARCH_CLAIMS_REQUEST,
  payload: { damagingName },
});

const searchInClaimsSuccess = (payload) => ({
  type: damagingNameConstants.SEARCH_CLAIMS_SUCCESS,
  payload,
});

const searchInClaimsFailure = (error) => ({
  type: damagingNameConstants.SEARCH_CLAIMS_FAILURE,
  error,
});

const searchInContacts = (name) => ({
  type: damagingNameConstants.SEARCH_CONTACTS_REQUEST,
  payload: { name },
});

const searchInContactsSuccess = (payload) => ({
  type: damagingNameConstants.SEARCH_CONTACTS_SUCCESS,
  payload,
});

const searchInContactsFailure = (error) => ({
  type: damagingNameConstants.SEARCH_CONTACTS_FAILURE,
  error,
});

const deleteDamagingParties = (ids) => ({
  type: damagingNameConstants.DELETE_DAMAGING_REQUEST,
  payload: { ids },
});

const deleteDamagingPartiesSuccess = (payload) => ({
  type: damagingNameConstants.DELETE_DAMAGING_SUCCESS,
  payload,
});

const deleteDamagingPartiesFailure = (error) => ({
  type: damagingNameConstants.DELETE_DAMAGING_FAILURE,
  error,
});

const updateClaimNames = (ids, newName) => ({
  type: damagingNameConstants.UPDATE_CLAIMS_REQUEST,
  payload: { ids, newName },
});

const updateClaimNamesSuccess = (payload) => ({
  type: damagingNameConstants.UPDATE_CLAIMS_SUCCESS,
  payload,
});

const updateClaimNamesFailure = (error) => ({
  type: damagingNameConstants.UPDATE_CLAIMS_FAILURE,
  error,
});

const updateContactNames = (ids, newName) => ({
  type: damagingNameConstants.UPDATE_CONTACTS_REQUEST,
  payload: { ids, newName },
});

const updateContactNamesSuccess = (payload) => ({
  type: damagingNameConstants.UPDATE_CONTACTS_SUCCESS,
  payload,
});

const updateContactNamesFailure = (error) => ({
  type: damagingNameConstants.UPDATE_CONTACTS_FAILURE,
  error,
});

export const damagingNameActions = {
  searchAdminDamagingParties,
  searchDamagingPartiesSuccess,
  searchDamagingPartiesFailure,
  searchByClaimId,
  searchByClaimIdSuccess,
  searchByClaimIdFailure,
  searchInClaims,
  searchInClaimsSuccess,
  searchInClaimsFailure,
  searchInContacts,
  searchInContactsSuccess,
  searchInContactsFailure,
  deleteDamagingParties,
  deleteDamagingPartiesSuccess,
  deleteDamagingPartiesFailure,
  updateClaimNames,
  updateClaimNamesSuccess,
  updateClaimNamesFailure,
  updateContactNames,
  updateContactNamesSuccess,
  updateContactNamesFailure,
};
